"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyQuantile = void 0;
const utilityFunctions_1 = require("../../utilities/utilityFunctions");
function applyQuantile(factory, src, selector, q) {
    const sorted = factory
        .createBasicEnumerable((0, utilityFunctions_1.getIterableGenerator)(src))
        .select(selector)
        .orderBy(x => x)
        .toArray();
    const pos = (sorted.length - 1) * q;
    const base = Math.floor(pos);
    const rest = pos - base;
    if (sorted[base + 1] !== undefined) {
        return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
    }
    else {
        return sorted[base];
    }
}
exports.applyQuantile = applyQuantile;
//# sourceMappingURL=applyQuantile.js.map